import apiFetch from '../apiFetch'

export default function (token, organizedUnitId, financingCompanyId) {
  return apiFetch({ endPoint: 'FinanceCompany/RecoverCompanyFromUo/' + financingCompanyId + '/' + organizedUnitId, method: 'DELETE', body: null, token: token })
}
